import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  teachersData: [],
  totalTeachers: 0,
  isOpenModal: false,
  isStatusOpenModal: false,
  isImageOpenModal: false,

}

export const teachersSlice = createSlice({
  name: "teachers",
  initialState,
  reducers: {
    setTeachersData(state, { payload }) {
      state.teachersData = payload.result
      state.totalTeachers = payload.count
    },
    updateTeachersData(state, { payload }) {
      const objIndex = state.teachersData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.teachersData[objIndex] = payload
      }
    },
    updateTeachersImageData(state, { payload }) {
      const objIndex = state.teachersData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.teachersData[objIndex] = payload
      }
    },
    deleteTeachersData(state, { payload }) {
      const objIndex = state.teachersData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.teachersData.splice(objIndex, 1)
        state.totalTeachers = state.totalTeachers - 1
      }
    },
    pushTeachersData(state, { payload }) {
      state.teachersData.push(payload)
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    },
    isImageOpenModal(state, { payload }) {
      state.isImageOpenModal = payload
    },
    ImagestatusToggle(state, { payload }) {
      state.isImageOpenModal = !state.isImageOpenModal
    }
  }
})

export const { setTeachersData, updateTeachersData, deleteTeachersData, pushTeachersData, isOpenModal,
  ModalToggle, isOpenStatusModal, statusToggle, ImagestatusToggle, isImageOpenModal, updateTeachersImageData } = teachersSlice.actions;

export default teachersSlice.reducer;

export function getTeachers(limit, offset) {
  return async function getTeachersThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getTeachers(limit, offset).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setTeachersData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addTeachers(payload) {
  return async function addTeachersThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addTeachers(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushTeachersData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateTeachers(id, data) {
  return async function updateTeachersThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateTeachers(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateTeachersData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function deleteTeacher(id) {
  return async function statuseleteTeachersThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteTeacher(id).then(
        (response) => {
          dispatch(deleteTeachersData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateteachersImage(id, file) {
  return async function updateteachersImageThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      dispatch(isImageOpenModal())
      await service.teachersImage(id, file).then(
        (response) => {
          dispatch(updateTeachersImageData(response.data))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


